module.exports = __webpack_public_path__ + "img/absolute-radio-00s.1f8a2804.png";